import { reactive } from "vue";
import { Options } from "vue-class-component";
import { parse, format } from "date-fns";

import config from "@/config/config";
import i18n from "@/translation/i18n";
import PageBaseList from "@/pages/PageBaseList";
import TableLite from "@/components/table/TableLiteTs.vue";
import { Order } from "@/domain/order.model";
import { UtilDate } from "@/helpers/date";

const { t } = i18n.global;

@Options({
  name: "order-list",
  components: {
    TableLite,
  },
  computed: {
    isLoading(): boolean {
      return this.$store.state.order.isLoading;
    },
    totalRecordCount(): number {
      return this.$store.state.order.orders?.total;
    },
    orders(): Order[] {
      return this.$store.state.order.orders?.data;
    },
  },
  watch: {
    orders: function () {
      this.table.rows = this.orders;
      this.table.totalRecordCount = this.totalRecordCount;
    },
    isLoading: function () {
      this.table.isLoading = this.isLoading;
    },
  },
})
export default class OrderList extends PageBaseList {
  public format = "";
  public table = TABLE;
  public filterOrder = {
    name: null,
    payment: null,
    dateIni: null,
    dateEnd: null,
    status: null,
  };

  public mounted(): void {
    this.url = "order";
    this.module = config.modules.order;
    this.table.rows = [];

    this.doSearch(0, this.per_page, "id", "asc");
  }

  public computed(): void {
    this.url = "order";
    this.module = config.modules.order;
    this.table.rows = [];

    this.doSearch(0, this.per_page, "id", "asc");
  }

  public doFilter() {
    this.doSearch(0, this.per_page, "id", "asc", this.filterOrder);
  }

  public formatDate(date: string | Date): string {
    return date ? UtilDate.format(date, "DD/MM/YYYY") : "";
  }

  public formatNumber(value) {
    return value ? Number(value).toFixed(2) : "-";
  }

  public doSearch(offset?: number, limit?: number, order?: string, sort?: string, filter?: Record<string, unknown>) {
    this.table.isReSearch = offset == undefined ? true : false;

    if (offset >= 10 || limit >= this.max_per_page) {
      limit = this.max_per_page;
    }

    const filterWithFormattedDates = {
      ...filter,
      dateIni: this.filterOrder.dateIni
        ? format(parse(this.filterOrder.dateIni, "dd/MM/yyyy", new Date()), "yyyy/MM/dd")
        : null,
      dateEnd: this.filterOrder.dateEnd
        ? format(parse(this.filterOrder.dateEnd, "dd/MM/yyyy", new Date()), "yyyy/MM/dd")
        : null,
    };

    this.$store
      .dispatch("order/list", { offset, limit, order, sort, filter: filterWithFormattedDates })
      .then(() => {
        this.table.sortable.order = order;
        this.table.sortable.sort = sort;
      })
      .catch(error => {
        console.log(error);
      });
  }

  public excluir(id: string | number) {
    this.$store
      .dispatch("order/delete", id)
      .then(() => {
        this.table.isLoading;
      })
      .catch(() => {
        this.errorMessage = "Ocorreu um erro ao excluir.";
      });
  }

  public clear() {
    this.filterOrder = {
      name: null,
      payment: null,
      dateIni: null,
      dateEnd: null,
      status: null,
    };
    this.doSearch(0, this.per_page, "id", "asc");
  }
}

export const TABLE = reactive({
  isLoading: false,
  isReSearch: false,
  columns: [
    {
      label: t("labels.entity.id"),
      field: "id",
      sortable: true,
      isKey: true,
    },
    {
      label: t("labels.entity.customer"),
      field: "customer.name",
      sortable: true,
      columnStyles: "text-align: left; max-width: 150px",
    },
    {
      label: t("labels.entity.payment"),
      field: "payment.transaction_code",
      sortable: true,
      columnStyles: "max-width: 150px",
    },
    {
      label: t("labels.entity.amount"),
      field: "amount",
      sortable: true,
      columnStyles: "text-align: right; max-width: 30px",
    },
    {
      label: t("labels.entity.createdAt"),
      field: "createdAt",
      sortable: true,
      columnStyles: "max-width: 50px",
    },
    {
      label: t("labels.entity.expireIn"),
      field: "expire_in",
      sortable: true,
    },
    {
      label: t("labels.entity.status"),
      field: "status",
      sortable: true,
      columnStyles: "max-width: 100px",
    },
    {
      field: "actions",
    },
  ],
  rows: [],
  totalRecordCount: 0,
  sortable: {
    order: "id",
    sort: "asc",
  },
});
